export default "__VITE_ASSET__d8cae947__"